import React, { Component } from 'react';
import PropTypes from 'prop-types';

/**
 * @class WithClickOutside
 * @classdesc Reusable WithClickOutside Component
 * @property {Object} state
 * @example ./WithClickOutside.md
 */
export default class WithClickOutside extends Component {
  static propTypes = {
    handleClickOutside: PropTypes.func.isRequired,
    className: PropTypes.string,
    style: PropTypes.objectOf(
      PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
      ]),
    ),
  };

  static defaultProps = {
    className: null,
    style: null,
  };

  constructor(props) {
    super(props);
    this.wrapperRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  /**
   * @description Verifies if click locations are outside of component or not
   * @param {Object} - Event object
   * @return {(Function|void)} - return handleClose or nothing based on click location
   */
  handleClickOutside = e => {
    const { handleClickOutside } = this.props;
    if (this.wrapperRef && !this.wrapperRef.current.contains(e.target)) handleClickOutside();
  };

  render() {
    const { children, className, style } = this.props;

    return (
      <div className={className} ref={this.wrapperRef} style={style}>
        {children}
      </div>
    );
  }
}
